import apiClient from './client'
import type { ApiResponse, TrustedDevice, PendingDevice } from '@portal/types'

export const devicesApi = {
  getPending: () =>
    apiClient.get('/api/devices/pending') as unknown as Promise<ApiResponse<PendingDevice[]>>,

  approve: (id: string) =>
    apiClient.post(`/api/devices/${id}/approve`) as unknown as Promise<ApiResponse<void>>,

  reject: (id: string) =>
    apiClient.post(`/api/devices/${id}/reject`) as unknown as Promise<ApiResponse<void>>,

  getMyDevices: () =>
    apiClient.get('/api/devices/mine') as unknown as Promise<ApiResponse<TrustedDevice[]>>,

  revokeMyDevice: (id: string) =>
    apiClient.delete(`/api/devices/mine/${id}`) as unknown as Promise<ApiResponse<void>>,
}
